export default {
  id: 219,
  title: 'Target #219 - CodePen',
  url: 'https://cssbattle.dev/play/219',
  colors: ['#101724', '#FFFFFF'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{left:135.5;width:95;height:95;transform:skew(10deg,10deg);rotate:-45deg;border:17px solid #fff}body{background:#101724}p{position:fixed;margin:0}p[a]{top:51}p[b]{top:121}p[c]{top:115;left:92.5;width:20;height:70;background:#fff;box-shadow:97.5px -60px #fff,97.5px 60px #fff,195px 0 #fff',
}
